import { render, staticRenderFns } from "./PesquisaChat.vue?vue&type=template&id=4c9d8fa9&scoped=true"
import script from "./PesquisaChat.vue?vue&type=script&lang=js"
export * from "./PesquisaChat.vue?vue&type=script&lang=js"
import style0 from "./PesquisaChat.vue?vue&type=style&index=0&id=4c9d8fa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9d8fa9",
  null
  
)

export default component.exports